export interface BaseModel {
  id: number
  createdAt: string
  updatedAt: string
}

export interface PaginatedResponseMeta {
  total: number
  perPage: number
  currentPage: number
  lastPage: number
  firstPage: number
  firstPageUrl: string
  lastPageUrl: string
  nextPageUrl: string | null
  previousPageUrl: string | null
}

export interface PaginatedResponse<T> {
  data: T[]
  meta: PaginatedResponseMeta
}

export interface Attachment {
  url: string
  name: string
  extname: string
  size: number
  mimeType: string
}

export enum QueryParams {
  PAGE = 'page',
  PER_PAGE = 'perPage',
  ORDER_BY = 'orderBy',
  ORDER = 'order',
  PARTS = 'parts'
}

export type OptionsFlags<Type> = {
  [Property in keyof Type]: boolean
}

export type ORDER = 'asc' | 'desc'

export interface PaginationParams<T> {
  [QueryParams.PAGE]?: number
  [QueryParams.PER_PAGE]?: number
  [QueryParams.ORDER_BY]?: keyof T
  [QueryParams.ORDER]?: ORDER
}

export interface Exception {
  message: string
  code: number
}

export interface UnprocessableEntityException<T = {}> {
  errors: { rule: string; field: keyof T; message: string }[]
}

export enum UrlProviderLocation {
  S3 = 's3',
  R2 = 'r2'
}
